module.exports = __webpack_public_path__ + "img/Ahmed_Tahous.67400879.png";